module.exports = __webpack_public_path__ + "static/media/installation-video-android-DA.a25d0d4f.mp4";